import { Inject } from 'vue-di-container';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Toaster } from '../../../Services/toast';
import UserRoleService from '../../../shared/userService/UserRoleService';
import UserService from '../../../shared/userService/UserService';
import WithRender from './RatingResults.html';
import RatingService from '../../Rating/RatingService';
import { FilterModel } from './FilterModel';
import { ServiceRatingModel } from '../../Rating/ServiceRatingModel';
import { RatingServiceType } from '../../Rating/RatingServiceType';
import { RatingResultsBoxModel } from './RatingResultsBoxModel';
import moment from 'moment';

@WithRender
@Component({
    diProvide: [
        UserService,
        UserRoleService,
        RatingService,
    ],
})
export default class RatingResults extends Vue {
    @Inject(RatingService) public ratingService!: RatingService;
    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;
    public ratingResults: ServiceRatingModel[] = [];
    public boxModel: RatingResultsBoxModel = {} as RatingResultsBoxModel;
    private debounceTimer: any = null;
    public DateFrom: boolean = false;
    public DateTo: boolean = false;

    public onProviderInput() {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
            this.pagination.page = 1;
            this.search();
        }, 300);
    }

    public filterModel: FilterModel = {
        providerName: '',
        serviceType: null,
        dateFrom: '',
        dateTo: ''
    };

    public pagination = {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
    }; public headers: any = [
        { text: this.$t('shared.providerName'), sortable: false, value: 'providerName', align: 'center' },
        { text: this.$t('shared.serviceName'), sortable: false, value: 'serviceType', align: 'center' },
        { text: this.$t('shared.ratingScale'), sortable: false, value: 'rating', align: 'center' },
        { text: this.$t('shared.ratingDate'), sortable: false, value: 'lastModifiedDate', align: 'center' },
        { text: this.$t('shared.comment'), sortable: false, value: 'reason', align: 'center' },
    ];

    public async mounted() {
        await this.GetBoxes();
        await this.search();
    }

    public async search() {
        const response = await this.ratingService.getRatings(
            this.filterModel.providerName,
            this.filterModel.serviceType,
            this.filterModel.dateFrom,
            this.filterModel.dateTo,
            (this.pagination.page - 1).toString(),
            this.pagination.rowsPerPage.toString()
        );

        if (response && response.isSuccess) {
            this.ratingResults = response.result;
            this.pagination.totalItems = response.totalCount || response.result.length;
        } else {
            Toaster.error(response.errorMessage);
        }
    }

    public async updatePaginate(val: any) {
        this.pagination.page = val.page;
        this.pagination.rowsPerPage = val.rowsPerPage;
        await this.search();
    }

    public async GetBoxes() {
        const response = await this.ratingService.GetBoxes();
        if (response && response.isSuccess) {
            this.boxModel = response.result;
        } else {
            console.log(response.errorMessage);
        }
    }

    public async filter(serviceType: number | null) {
        if (serviceType === null) {
            this.filterModel.serviceType = null;
        } else {
            if (this.filterModel.serviceType === serviceType) {
                this.filterModel.serviceType = null;
            } else {
                this.filterModel.serviceType = serviceType;
            }
        }

        this.pagination.page = 1;
        await this.search();
    }

    public getServiceName(serviceType: number): string {
        switch (serviceType) {
            case RatingServiceType.SenderNameRegistration:
                return this.$t('shared.senderNameRegistration').toString();
            case RatingServiceType.ContractRequest:
                return this.$t('shared.contractRequest').toString();
            case RatingServiceType.ConnectivityRequest:
                return this.$t('shared.connectivityShortcode').toString();
            default:
                return '-';
        }
    }

    public async reset() {
        this.filterModel.providerName = '';
        this.filterModel.serviceType = null;
        this.filterModel.dateFrom = '';
        this.filterModel.dateTo = '';
        this.pagination.page = 1;

        await this.search();
    }

    public formatDate(dateString: string): string {
        return dateString ? moment(dateString).format('YYYY-MM-DD') : '';
    }

     public onDateChange(field: 'from' | 'to') {
     if (field === 'from') this.DateFrom = false;
     if (field === 'to') this.DateTo = false;

     this.search();
 }
}